/* @flow weak */
import app from './app/reducer';
import auth from './auth/reducer';
import config from './config/reducer';
import device from './device/reducer';
import intl from './intl/reducer';
import users from './users/reducer';
import menu from './menu/reducer';
import categories from './categories/reducer';
import paymentPopup from './paymentPopup/reducer';
import branches from './branches/reducer';
import logs from './logs/reducer';
import bars from './bars/reducer';
import offers from './offers/reducer';
import keyboard from './components/keyboard/reducer';
import cashboxes from './cashboxes/reducer';
import tables from './tables/reducer';
import favourite from './menu/favourite/reducer';
import barReportCashboxes from './menu/report/cashboxes/reducer';
import shifts from './menu/report/shifts/reducer';
import transactions from './menu/report/transaction/reducer';
import login from './login/reducer';
import loadings from './components/loadings/reducer';
import messages from './components/messages/reducer';
import barReport from './report/reducer';
import barReportReceipt from './report/receipt/reducer';
import menuHabitues from './menu/credit/habitues/reducer';
import menuDebtDetail from './menu/credit/debtDetail/reducer';
import creditBill from './creditBill/reducer';
import {combineReducers} from 'redux';
import {fieldsReducer as fields} from './lib/redux-fields';
import {updateStateOnStorageLoad} from './configureStorage';

const resetStateOnSignOut = (reducer, initialState) => (state, action) => {
    // const userWasSignedOut =
    //     action.type === FIREBASE_ON_AUTH &&
    //     state.users.viewer && !action.payload.user;
    // if (userWasSignedOut) {
        // Preserve state without sensitive data.
        // state = {
        //     app: state.app,
        //     config: initialState.config,
        //     device: initialState.device,
        //     intl: initialState.intl
        // };
    // }
    return reducer(state, action);
};

const configureReducer = (initialState: Object) => {
    let reducer = combineReducers({
        app,
        barReportCashboxes,
        creditBill,
        categories,
        paymentPopup,
        auth,
        config,
        device,
        fields,
        shifts,
        intl,
        users,
        logs,
        login,
        menu,
        branches,
        bars,
        cashboxes,
        tables,
        loadings,
        offers,
        keyboard,
        messages,
        barReport,
        barReportReceipt,
        favourite,
        transactions,
        menuDebtDetail,
        menuHabitues
    });

    // The power of higher-order reducers, http://slides.com/omnidan/hor
    reducer = resetStateOnSignOut(reducer, initialState);
    reducer = updateStateOnStorageLoad(reducer);

    return reducer;
};

export default configureReducer;



// WEBPACK FOOTER //
// ./src/common/configureReducer.js